import { TEST_WEBINAR_MAX_VIEWERS } from '@core/types';
import { AccessDenied } from '@core/ui';
import { useTranslation } from 'react-i18next';

/** Shown when the server refused the join with DisconnectReason.TestWebinarFull (spec §5.3). */
export const TestWebinarFull = () => {
    const { t } = useTranslation();

    return (
        <div
            data-testid="test-webinar-full"
            className="flex-1 max-w-4xl flex flex-col items-center justify-center mx-auto px-4 py-8 md:px-8 lg:px-12 text-center"
        >
            <AccessDenied classNames="w-10 md:w-12 lg:w-16 stroke-warning mb-4" />
            <p>{t('Viewer.Message.TestWebinarFull', { maxViewers: TEST_WEBINAR_MAX_VIEWERS })}</p>
        </div>
    );
};
